export const Const_PermissionKeyType = 'permission-key';
//# sourceMappingURL=types.js.map